export default __webpack_public_path__ + "static/media/1103.d47af2fd.png";